<script setup lang="ts">
import { EventListPageType } from '~/composables/types/strapiEventListPage'

definePageMeta({
  contentGroup: 'city category',
  localeSpecificSlug: true,
})
</script>

<template>
  <event-list-page
    :page-type="EventListPageType.CITY_CATEGORY"
  ></event-list-page>
</template>
